/**
 * FAQ 頁面與首頁共用的 FAQ 項目
 * 標題／內文由 translations homePage.faq1Q/A ~ faq9Q/A 提供
 */
export const FAQ_IDS = [
  'faq1',
  'faq2',
  'faq3',
  'faq4',
  'faq5',
  'faq6',
  'faq7',
  'faq8',
  'faq9',
];
